function OriginalOverlay(options) {
    $.extend(this, new google.maps.OverlayView);

    window.mapOverlay = {};

    var self = this;
    var pinnable = options.pinnable;
    this.el = options.el;

    this.overlayContent = document.createElement('div');

    $(this.overlayContent).append('<h3>' + pinnable.title + '</h3>');
    $(this.overlayContent).append('<p>' + pinnable.intro + '</p>');
    if (window.location.pathname != pinnable.url) {
        $(this.overlayContent).append('<p class="more"><strong>Read More</strong></p>');
    }

    var width = $('body').innerWidth();
    if( pinnable.img && width > 450) {
        $(this.overlayContent).append('<img src="' + pinnable.img + '" />');
        $(this.overlayContent).addClass('image');
    }
    $(this.overlayContent).addClass('overlay-content');

    var close = $('<div>').addClass('overlay-content__close').html(svg('close')).appendTo($(this.overlayContent));

    close.on('click', function(e) {
        e.stopPropagation();
        self.close();
    });

    if (window.location.pathname != pinnable.url) {
        $(this.overlayContent).on('click', function() {
            if( pinnable.url ) {
                window.location = pinnable.url;
            }
        });
    }

    this.setValues(options);

    this.isOpen = false;

}

OriginalOverlay.prototype.onAdd = function() {
    var location = window.mapOverlay.location;
    var map = window.mapOverlay.map;

    this.getPanes().overlayMouseTarget.appendChild( this.overlayContent );

    var loc = new google.maps.LatLng(location.position.lat(), location.position.lng());
    var _px = this.fromLatLngToPoint(loc, map);


    // Recalculate based on the width of the overlay
    _px.x += $(this.overlayContent).innerWidth() / 2;

    // Recalculate based on the left position of the overlay
    _px.x += 40;

    // Recalculate based on the height of the overlay
    if ($(this.overlayContent).innerHeight() < $(this.el).height()) {
        _px.y += $(this.overlayContent).innerHeight() / 2;
    } else {
        _px.y += $(this.el).innerHeight() / 2;
    }

    // Recalculate based on the top position of the overlay
    _px.y -= 51;

    var _lat = this.fromPointTolatLng(_px, map);

    var loc = new google.maps.LatLng(_lat.lat(), _lat.lng());
    map.setCenter(loc);
}

OriginalOverlay.prototype.draw = function() {
    var projection = this.getProjection();

    if( !projection )
    return; // Not Ready for drawing

    var latLng = this.get('position');
    if( !latLng ) {
        this.close();
        return;
    }

    var point = projection.fromLatLngToDivPixel( latLng );
    this.overlayContent.style.top =  (point.y - 51) + 'px';
    this.overlayContent.style.left = (point.x + 40) + 'px';
};

OriginalOverlay.prototype.open = function( map, location ) {
    var self = this;

    if( map ) {
        this.setMap(map);
        window.mapOverlay.map = map;
    }

    if( location ) {
        this.set('anchor', location);
        this.bindTo('position', location);
        window.mapOverlay.location = location;
    }

    this.draw();

    var latLng = this.get('position');

    $(self.overlayContent).addClass('overlay-content-making-visible');
    setTimeout(function() {
        // YIELD to the browser
        $(self.overlayContent).addClass('overlay-content-visible');
    }, 20);

    this.isOpen = true;
};


OriginalOverlay.prototype.fromLatLngToPoint = function(latLng, map) {
    var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var scale = Math.pow(2, map.getZoom());
    var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
    return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

OriginalOverlay.prototype.fromPointTolatLng = function(point, map) {
    var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var scale = Math.pow(2, map.getZoom());
    return map.getProjection().fromPointToLatLng(new google.maps.Point((point.x / scale) + bottomLeft.x, (point.y / scale) + topRight.y));
}

OriginalOverlay.prototype.close = function( ) {
    var self = this;

    $(this.overlayContent).removeClass('overlay-content-visible');
    setTimeout(function() {
        $(self.overlayContent).removeClass('overlay-content-making-visible');
    }, 200);
    this.isOpen = false;
};

OriginalOverlay.prototype.remove = function() {
    this.close();
};

OriginalIcon = function(type) {
    return {
        url: '/images/pin-' + type + '.png',
        size: new google.maps.Size(41, 51),
        anchor: new google.maps.Point(19, 48)
    };
};

function mapLazyload(api_key) {
    if (typeof api_key !== 'undefined') {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + api_key, function() {initGmap();});
    }
};

function initGmap() {
    var $elem_wrap = $('#fullscreen-map'),
        $elem = $elem_wrap.find('.inner-map');

    var itin = false;
    if ($elem_wrap.hasClass('map-content__map')) {
        itin = true
    }

    var swlat = parseFloat($elem_wrap.data('swlat')),
        swlng = parseFloat($elem_wrap.data('swlng')),
        nelat = parseFloat($elem_wrap.data('nelat')),
        nelng = parseFloat($elem_wrap.data('nelng')),
        loclat = parseFloat($elem_wrap.data('lat')),
        loclng = parseFloat($elem_wrap.data('lng')),
        centertype = $elem_wrap.data('center'),
        zoom = 10

    if ($elem_wrap.data('zoom')) {
        zoom = parseFloat($elem_wrap.data('zoom'));
    }

    var map = null;
    var markers = [];
    var activemarker = null;

    var loadmap = function() {
        if (map !== null || $elem.length == 0) { return; }

        map = new google.maps.Map( $elem[0], {
            center: new google.maps.LatLng(swlat, swlng),
            zoom: zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true
        });

        $.ajax({
            url: $elem_wrap.data('pinsource'),
            dataType: 'json'
        }).done(function(data) {
            $.each(data, function(index, pinnable) {

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(pinnable.location[0], pinnable.location[1]),
                    map: map,
                    title: pinnable.title,
                    icon: OriginalIcon(pinnable.type),
                    type: pinnable.type
                });

                markers.push(marker);

                var infowindow = new OriginalOverlay({
                    pinnable: pinnable,
                    el: $elem[0],
                    activemarker: activemarker
                });

                if (pinnable.title == $elem_wrap.data('currentdest'))
                {
                    infowindow.open(map, marker);
                }

                google.maps.event.addListener(marker, 'click', function() {
                    // Default overlay/popup behaviour
                    if (!itin) {
                        if ( infowindow.isOpen ) {
                            infowindow.close();
                            return;
                        }

                        if( activemarker && activemarker.isOpen ) {
                            activemarker.close();
                        }

                        activemarker = infowindow;
                        infowindow.open(map, marker);
                    } else {
                        var title = marker.title;
                        // Find id of itinerary from listing
                        $('.result__title:contains(' + title + ')', '.map-content__results').closest('a').trigger('click');
                    }
                });
            });

            google.maps.event.addListener(map, 'click', function() {
                if( activemarker && activemarker.isOpen ) {
                    activemarker.close();
                }
            });

            mapFilters(markers, map);
        });
    };

    var recenter = function() {
        if ('location' == centertype) {
            var loc = new google.maps.LatLng(loclat, loclng);
            map.setCenter(loc);
        } else {
            var bounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(swlat, swlng),
                new google.maps.LatLng(nelat, nelng)
            );

            map.fitBounds(bounds);
        }
    };

    $elem_wrap.find('.close').on('click touchend', function(e) {
        e.preventDefault();
        $elem_wrap.hide();
        if( '_gaq' in window ) {
            _gaq.push(['_trackEvent', 'Map', 'Close', window.location.pathname, undefined, true]);
        }
    });

    window.initMap = function() {
        loadmap();
        $elem_wrap.show();
        google.maps.event.trigger(map, 'resize');
        recenter();
    };

    var mapFilters = function(markers, defaultMap) {
        var options = [];
        $.each(markers, function(i, marker) {
            if (options[marker.type] == undefined) {
                options[marker.type] = [];
            }
            options[marker.type].push(marker);
        });

        var keys = Object.keys(options);

        if (keys.length <= 1) {
            return;
        }

        $('.map-content').attr('data-filter-count', keys.length).addClass('map-content--filterable');

        for(i = 0; i < keys.length; i++){
            var value = options[keys[i]];
            $('.map-content-filter[data-filter="' + keys[i] + '"]').addClass('map-content-filter--filterable');
            $('.map-content-filter[data-filter="' + keys[i] + '"]').find('.map-content-filter__count').html(value.length);
        }

        $('.map-content-filter').not('.map-content-filter--filterable').remove();

        $('.map-content-filter').on('click', function() {
            $(this).toggleClass('map-content-filter--active');
            var map = $(this).hasClass('map-content-filter--active') ? defaultMap : null;
            $.each(options[$(this).data('filter')], function(i, marker) {
                marker.setMap(map);
            });
        });

        $('.map-content-filter[data-filter="activity"]').trigger('click');
        $('.map-content-filter[data-filter="accommodation"]').trigger('click');
    };

    /*
     * Contact Map
     */
    (function() {
        var $contactmap = $('.contact #map');
        if( !$contactmap.length ) { return; }

        var lat = $contactmap.parent().data('lat'),
            lng = $contactmap.parent().data('lng');

        var mapoptions = {
                center: new google.maps.LatLng(lat, lng),
                zoom: 15,
                scrollwheel: false,
                draggable: $(document.body).hasClass('touch-mobile') ? false : true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControlOptions: {
                    position: google.maps.ControlPosition.BOTTOM_LEFT
                }
            };

        if ($('body').width() < 600)
        {
            mapoptions.disableDefaultUI = true;
        }

        map = new google.maps.Map( $('#map')[0], mapoptions);

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            map: map
        });

        $(window).on('resize', function() {
            $contactmap.width( $(window).width() );

            $contactmap.css('left', 0 - $('#inner-wrapper').offset().left );

            google.maps.event.trigger(map, 'resize');
            map.setCenter( new google.maps.LatLng(lat, lng) );
        }).trigger('resize');
    })();

    if ($('body').hasClass('map-init')) {
        window.setTimeout(initMap, 100);
    }

}
